import { render, staticRenderFns } from "./prevLessonView.vue?vue&type=template&id=53d3eba6&"
import script from "./prevLessonView.vue?vue&type=script&lang=js&"
export * from "./prevLessonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports